import React, { useEffect, useState } from "react";
import { Table, Divider, Popconfirm, Typography } from "antd";
import CallModal from "./CallModal";


export default function FilterTable(props) {
  const { pagination, dataSource, onRemove, editable, loader } = props;
  const [contacts,setContacts] = useState([]);
  const [name, setName] = useState("");
  const [open,setOpen] = useState(false);

  const column = [
    {
      title: "Customer Name",
      dataIndex: "name",
      key: "name",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Number",
      dataIndex: "contacts",
      key: "contacts",
      render: (record, data) => (
        <span>{record && record[0] ? record[0].phone : "-"}</span>
      ),
    },
    {
      title: "Customer Type",
      dataIndex: "customerType",
      key: "customerType",
      render: (record) => <span>{record}</span>,
    },

    {
      title: "Action",
      render: (data) => (
        <div>
          {
            <span className="linkylink" 
            onClick={(e)=>{
                e.stopPropagation();
                setName(data.name)
                setContacts(data.contacts)
                setOpen(true);
              }
            }>
              Call Customer
              </span>
          }
           <Divider type="vertical"/>

          {editable ? (
            <Popconfirm
              title="Do you want to delete this Provisional Customer?"
              okText="Yes"
              cancelText="No"
              onCancel={(event) => {
                event.stopPropagation();
              }}
              onConfirm={(event) => {
                onRemove(data.id);
              }}
            >
              <span className="linkylink">Remove</span>
            </Popconfirm>
          ) : (
              <span>Remove</span>
            )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <Table
      rowKey={(record) => record.id}
      pagination={pagination}
      columns={column}
      tableLayout="fixed"
      style={{ cursor: "pointer" }}
      dataSource={dataSource}
      // onRow={(props) => ({
      //    onClick: () => openModal(props.id, false),
      // })}
      loading={loader}
    />
    
    {open &&
      <CallModal 
        open={open}
        close={()=>{
          setOpen(false);
          setContacts([]);
          setName("");
        }}
        contacts={contacts}
        name={name}
      />
    }
    </div>
  );
}
